import React, { useMemo } from 'react';
import SidebarMenu from './SidebarMenu';
import { ADMIN_DASHBOARD_MENU_ITEMS, filterAdminMenuItems, groupAdminEntityMenuItems } from '../../../utils/adminMenu';
import useMensajesNoLeidos from '../../../hooks/useMensajesNoLeidos';

const buildAdminMenuItems = ({ user, featureFlags, baseItems = ADMIN_DASHBOARD_MENU_ITEMS }) => {
  return groupAdminEntityMenuItems(filterAdminMenuItems(baseItems, user, featureFlags));
};

const AdminMenu = ({ activeId, onNavigate, user, featureFlags = [], className = '', baseItems = ADMIN_DASHBOARD_MENU_ITEMS, messageScope = 'colegio' }) => {
  const { count: mensajesNoLeidos } = useMensajesNoLeidos(true, { scope: messageScope });
  const items = useMemo(() => {
    return buildAdminMenuItems({ user, featureFlags, baseItems }).map((item) => (
      item.id === 'mensajes' ? { ...item, badge: mensajesNoLeidos } : item
    ));
  }, [user, featureFlags, baseItems, mensajesNoLeidos]);

  return (
    <SidebarMenu
      items={items}
      activeId={activeId}
      onNavigate={onNavigate}
      className={className}
    />
  );
};

export { buildAdminMenuItems, ADMIN_DASHBOARD_MENU_ITEMS as BASE_ADMIN_ITEMS };
export default AdminMenu;
